import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { Layout } from "@/components/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import Portfolio from "@/pages/Portfolio";
import Process from "@/pages/Process";
import Contact from "@/pages/Contact";
import LegalPage from "@/pages/LegalPage";

function App() {
  return (
    <BrowserRouter>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/process" element={<Process />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy-policy" element={<LegalPage docKey="privacy" />} />
          <Route path="/terms-and-conditions" element={<LegalPage docKey="terms" />} />
          <Route path="/refund-policy" element={<LegalPage docKey="refund" />} />
          <Route path="/disclaimer" element={<LegalPage docKey="disclaimer" />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </Layout>
      <Toaster position="top-center" richColors theme="light" />
    </BrowserRouter>
  );
}

export default App;
